import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

export default class CommonMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    //ignore empty strings
    if(params?.key.trim() === '' || params?.key.toLowerCase() === 'init') {
      return ' ';
    }

    console.warn(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ Missing ${params?.translateService.currentLang} translation for key: ${params?.key}`, params);
    return `[${params?.key}]`;
  }
}
